(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-burst"] && !Shopify.designMode) return;
  try {
    
  function assignCommunityClasses() {
    document.querySelectorAll('.xo-community--spike').forEach(function (parent) {
      const children = parent.querySelectorAll('.xo-community-item__wrapper');
      const prefix = 'xo-community-item__wrapper--spike-';

      children.forEach(function (el, i) {
        el.classList.forEach((cls) => {
          if (cls.startsWith('xo-community-item__wrapper--spike-')) {
            el.classList.remove(cls);
          }
        });

        // Add new spike class
        el.classList.add(`${prefix}${i + 1}`);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', assignCommunityClasses);
  document.addEventListener('shopify:section:load', assignCommunityClasses);
  document.addEventListener('shopify:section:select', assignCommunityClasses);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community"] && !Shopify.designMode) return;
  try {
    
  function assignCommunityClasses() {
    document.querySelectorAll('.xo-community--rounded').forEach(function (parent) {
      const children = parent.querySelectorAll('.xo-community-item__wrapper');
      const prefix = 'xo-community-item__wrapper--rounded-';

      children.forEach(function (el, i) {
        el.classList.forEach((cls) => {
          if (cls.startsWith('xo-community-item__wrapper--rounded-')) {
            el.classList.remove(cls);
          }
        });

        // Add new rounded class
        el.classList.add(`${prefix}${i + 1}`);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', assignCommunityClasses);
  document.addEventListener('shopify:section:load', assignCommunityClasses);
  document.addEventListener('shopify:section:select', assignCommunityClasses);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-videos"] && !Shopify.designMode) return;
  try {
    
  function initInstagramVideosSection(sectionId) {
    const section = document.querySelector(`.instagram-videos-${sectionId}`);

    if (!section || section.dataset.instagramVideosReady === 'true') {
      return;
    }

    const track = section.querySelector('#InstagramVideos-' + sectionId + '-track');
    const slides = track ? Array.from(track.children) : [];
    const prevButton = section.querySelector('[data-instagram-videos-prev]');
    const nextButton = section.querySelector('[data-instagram-videos-next]');
    const dots = Array.from(section.querySelectorAll('[data-instagram-videos-dot]'));

    if (!track || slides.length < 2 || !prevButton || !nextButton || dots.length === 0) {
      section.dataset.instagramVideosReady = 'true';
      return;
    }

    let activeIndex = 0;

    function getDesktopBreakpoint() {
      return Number.parseInt(section.dataset.desktopBreakpoint || '1200', 10) || 1200;
    }

    function isDesktopGrid() {
      return window.innerWidth >= getDesktopBreakpoint();
    }

    function updateDots(index) {
      dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
    }

    function updateButtons(index) {
      if (isDesktopGrid()) {
        prevButton.disabled = true;
        nextButton.disabled = true;
        return;
      }

      prevButton.disabled = index <= 0;
      nextButton.disabled = index >= slides.length - 1;
    }

    function updateState(index) {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      updateDots(activeIndex);
      updateButtons(activeIndex);
    }

    function scrollToSlide(index) {
      const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
      const targetSlide = slides[targetIndex];

      if (!targetSlide) {
        return;
      }

      track.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: 'smooth',
      });

      updateState(targetIndex);
    }

    function syncFromScroll() {
      if (isDesktopGrid()) {
        updateButtons(activeIndex);
        return;
      }

      const trackLeft = track.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - trackLeft);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      if (closestIndex !== activeIndex) {
        updateState(closestIndex);
        return;
      }

      updateButtons(activeIndex);
    }

    prevButton.addEventListener('click', () => scrollToSlide(activeIndex - 1));
    nextButton.addEventListener('click', () => scrollToSlide(activeIndex + 1));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number.parseInt(dot.dataset.index || '0', 10);
        scrollToSlide(index);
      });
    });

    track.addEventListener('scroll', syncFromScroll, { passive: true });
    window.addEventListener('resize', syncFromScroll);

    updateState(0);
    section.dataset.instagramVideosReady = 'true';
  }

  function initAllInstagramVideosSections() {
    document.querySelectorAll('[data-instagram-videos-section]').forEach((section) => {
      const sectionClass = Array.from(section.classList).find((className) => className.indexOf('instagram-videos-') === 0);

      if (!sectionClass) {
        return;
      }

      initInstagramVideosSection(sectionClass.replace('instagram-videos-', ''));
    });
  }

  document.addEventListener('DOMContentLoaded', initAllInstagramVideosSections);
  document.addEventListener('shopify:section:load', initAllInstagramVideosSections);
  document.addEventListener('shopify:section:reorder', initAllInstagramVideosSections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const togglePassword = document.getElementById('togglePassword');
    const passwordField = document.getElementById('passwordField');
    const eyeOpenPassword = document.getElementById('password-icon-open');
    const eyeHidePassword = document.getElementById('password-icon-hide');

    togglePassword.addEventListener('click', function () {
      if (passwordField.type === 'password') {
        passwordField.type = 'text';
        eyeOpenPassword.classList.remove('d:none');
        eyeHidePassword.classList.add('d:none');
      } else {
        passwordField.type = 'password';
        eyeOpenPassword.classList.add('d:none');
        eyeHidePassword.classList.remove('d:none');
      }
    });

    const toggleConfirmPassword = document.getElementById('toggleConfirmPassword');
    const confirmPasswordField = document.getElementById('confirmPasswordField');
    const eyeOpenConfirmPassword = document.getElementById('password-confirm-icon-open');
    const eyeHideConfirmPassword = document.getElementById('password-confirm-icon-hide');

    toggleConfirmPassword.addEventListener('click', function () {
      if (confirmPasswordField.type === 'password') {
        confirmPasswordField.type = 'text';
        // eyeOpenConfirmPassword.classList.remove('xo-register__password-confirm-icon--hidden');
        // eyeHideConfirmPassword.classList.add('xo-register__password-confirm-icon--hidden');
        eyeOpenConfirmPassword.classList.remove('d:none');
        eyeHideConfirmPassword.classList.add('d:none');
      } else {
        confirmPasswordField.type = 'password';
        // eyeOpenConfirmPassword.classList.add('xo-register__password-confirm-icon--hidden');
        // eyeHideConfirmPassword.classList.remove('xo-register__password-confirm-icon--hidden');
        eyeOpenConfirmPassword.classList.add('d:none');
        eyeHideConfirmPassword.classList.remove('d:none');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reset-password"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const togglePassword = document.getElementById('togglePassword');
    const passwordField = document.getElementById('passwordField');
    const eyeOpenPassword = document.getElementById('password-icon-open');
    const eyeHidePassword = document.getElementById('password-icon-hide');

    togglePassword.addEventListener('click', function () {
      if (passwordField.type === 'password') {
        passwordField.type = 'text';
        eyeOpenPassword.classList.remove('d:none');
        eyeHidePassword.classList.add('d:none');
      } else {
        passwordField.type = 'password';
        eyeOpenPassword.classList.add('d:none');
        eyeHidePassword.classList.remove('d:none');
      }
    });

    const toggleConfirmPassword = document.getElementById('toggleConfirmPassword');
    const confirmPasswordField = document.getElementById('confirmPasswordField');
    const eyeOpenConfirmPassword = document.getElementById('password-confirm-icon-open');
    const eyeHideConfirmPassword = document.getElementById('password-confirm-icon-hide');

    toggleConfirmPassword.addEventListener('click', function () {
      if (confirmPasswordField.type === 'password') {
        confirmPasswordField.type = 'text';
        eyeOpenConfirmPassword.classList.remove('d:none');
        eyeHideConfirmPassword.classList.add('d:none');
      } else {
        confirmPasswordField.type = 'password';
        eyeOpenConfirmPassword.classList.add('d:none');
        eyeHideConfirmPassword.classList.remove('d:none');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
